import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { Spin } from "@arco-design/web-react";
import { isLocalAuthed } from "./Api/localAuth";
import { FetchApi } from "./Api/AuthenticatedApi";
import Content from "./Layout/Content";

// Route guard. Authenticated = a dev local-auth token OR an Auth0 session.
//
// Once authenticated, we call GET /api/me BEFORE rendering the app. That endpoint
// provisions the user on first login (creates their organization), so a brand-new
// Auth0 user exists in the DB before any page fires its org-scoped API calls
// (which would otherwise 400). We wait for /me to resolve either way so we never
// hard-block the app if it fails.
export default function RequireAuth({ children }) {
  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
  const authed = isLocalAuthed() || isAuthenticated;
  const [accountReady, setAccountReady] = useState(false);

  useEffect(() => {
    if (!authed) return;
    const done = () => setAccountReady(true);
    FetchApi(getAccessTokenSilently, "/api/me", done, done, done);
  }, [authed, getAccessTokenSilently]);

  if (authed) {
    if (!accountReady) {
      return (
        <Content>
          <Spin />
        </Content>
      );
    }
    return children;
  }
  if (isLoading) {
    return (
      <Content>
        <Spin />
      </Content>
    );
  }
  return <Navigate to="/login" replace />;
}
